import r from '../utils/request'
import { API_ROOT } from '../utils/constants'

// Printed cookbook beta (only for users switched on in the admin panel)

export const getCookbooks = () => r.get('/cookbooks')

export const getCookbook = (id) => r.get(`/cookbooks/${id}`)

// Creates a draft (no id) or updates one: group, chapters, title, dedication...
export const saveCookbook = (params) => r.post('/cookbooks', params)

export const saveCookbookCover = (id, file) =>
  r.upload(`/cookbooks/${id}/cover`, { cover_photo: file })

export const renderCookbook = (id) => r.post(`/cookbooks/${id}/render`)

export const getCookbookRender = (id) => r.get(`/cookbooks/${id}/render`)

// A photo that will likely print pixelated: decision is 'keep' or 'remove' (the answer is
// logged with the message shown). Returns the render status, rebuilding after a removal.
export const answerPhotoCheck = (id, key, decision) =>
  r.post(`/cookbooks/${id}/photo-checks`, { key, decision })

// Preview images and PDFs come back as signed links relative to the API
export const cookbookFileUrl = (link) => (link ? `${API_ROOT}${link}` : '')

// Morsel's price and shipping options for the built book at an address
export const getCookbookQuote = (id, params) => r.post(`/cookbooks/${id}/quote`, params)

// The API sends errors as { status: 'error', data: '10024: message' }
export const cookbookError = (err, fallback) => {
  const data = err?.response?.data?.data
  return typeof data === 'string' && data ? data.replace(/^\d+:\s*/, '') : fallback
}

// ---------- Orders (v1) ----------

export const checkoutCookbook = (id, params) => r.post(`/cookbooks/${id}/checkout`, params)

// "Request my book": for people who can't pay online yet (user.cookbook_self_serve is false).
// Saves the order details; the Morsel team emails them to finish the order.
export const requestCookbookOrder = (id, params) => r.post(`/cookbooks/${id}/order-request`, params)

// Their requested books the Morsel team hasn't finished yet
export const getCookbookOrderRequests = () => r.get('/cookbook-orders/requests')

export const REQUEST_STATUS_TEXT = {
  new: 'Requested: we’ll email you',
  contacted: 'Requested: check your email',
}

// The PDF export screen: the clean PDFs for Pro, an upgrade prompt for the free plan
export const getCookbookExport = (id) => r.get(`/cookbooks/${id}/export`)

// Recipes in the book with card photos or a voice memo, and how they print
export const getRecipeOptions = (id) => r.get(`/cookbooks/${id}/recipe-options`)

// The page a printed QR code opens (no sign-in), and the owner's switch for it
export const getListenPage = (token) => r.get(`/listen/${token}`)

export const setVoiceLink = (recipeId, off) => r.put(`/recipes/${recipeId}/listen`, { off })

export const getCookbookOrders = () => r.get('/cookbook-orders')

export const getCookbookOrder = (id) => r.get(`/cookbook-orders/${id}`)

export const cancelCookbookOrder = (id) => r.post(`/cookbook-orders/${id}/cancel`)

export const US_STATES = [
  ['AL', 'Alabama'],
  ['AK', 'Alaska'],
  ['AZ', 'Arizona'],
  ['AR', 'Arkansas'],
  ['CA', 'California'],
  ['CO', 'Colorado'],
  ['CT', 'Connecticut'],
  ['DE', 'Delaware'],
  ['DC', 'District of Columbia'],
  ['FL', 'Florida'],
  ['GA', 'Georgia'],
  ['HI', 'Hawaii'],
  ['ID', 'Idaho'],
  ['IL', 'Illinois'],
  ['IN', 'Indiana'],
  ['IA', 'Iowa'],
  ['KS', 'Kansas'],
  ['KY', 'Kentucky'],
  ['LA', 'Louisiana'],
  ['ME', 'Maine'],
  ['MD', 'Maryland'],
  ['MA', 'Massachusetts'],
  ['MI', 'Michigan'],
  ['MN', 'Minnesota'],
  ['MS', 'Mississippi'],
  ['MO', 'Missouri'],
  ['MT', 'Montana'],
  ['NE', 'Nebraska'],
  ['NV', 'Nevada'],
  ['NH', 'New Hampshire'],
  ['NJ', 'New Jersey'],
  ['NM', 'New Mexico'],
  ['NY', 'New York'],
  ['NC', 'North Carolina'],
  ['ND', 'North Dakota'],
  ['OH', 'Ohio'],
  ['OK', 'Oklahoma'],
  ['OR', 'Oregon'],
  ['PA', 'Pennsylvania'],
  ['PR', 'Puerto Rico'],
  ['RI', 'Rhode Island'],
  ['SC', 'South Carolina'],
  ['SD', 'South Dakota'],
  ['TN', 'Tennessee'],
  ['TX', 'Texas'],
  ['UT', 'Utah'],
  ['VT', 'Vermont'],
  ['VA', 'Virginia'],
  ['WA', 'Washington'],
  ['WV', 'West Virginia'],
  ['WI', 'Wisconsin'],
  ['WY', 'Wyoming'],
]

export const ORDER_STATUS_TEXT = {
  paid: 'Paid: going to the printer soon',
  submitted: 'Sent to the printer',
  in_production: 'Being printed',
  shipped: 'On its way',
  delivered: 'Delivered',
  failed: 'Needs our attention: we will be in touch',
  refunded: 'Refunded',
  cancelled: 'Cancelled',
  pending_payment: 'Waiting for payment',
}
